export const EMPTY_VALUE_STRING_ALIAS = 'none'
export const PACKAGING_ATTRIBUTE_KEY = 'Packaging'
export const UPSELL_ATTRIBUTE_KEY = '_isUpsell'
export const UPSELL_ORIGINAL_ATTRIBUTE_KEY = '_original_url'
